<template>
  <section
    :id="module.id"
    class="gallery-section"
    :style="[galleryWrapperElStyles, modulePadding]"
  >
    <div class="inner-wrapper">
      <div class="gallery-wrapper">
        <component
          :is="submodule.component.substring(2) + 'Module'"
          v-for="submodule in module.modules"
          :key="submodule.id"
          :module="submodule"
          :parent="module"
          :is-nested-module="true"
          :lazy="lazy"
          @emittedClick="$emit('emittedClick', { module, child: submodule })"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { globalComputed, globalMethods } from "../GlobalUI/mixins/global.js";
import galleryModule from "./galleryDefaultModuleProp.js";
import Text from "../Text/Text.vue";
import Video from "../Video/Video.vue";

export default {
  name: "Gallery",
  components: {
    TextModule: Text,
    VideoModule: Video,
  },
  mixins: [globalComputed, globalMethods],
  props: {
    module: {
      type: Object,
      default() {
        return galleryModule;
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    galleryWrapperElStyles() {
      const { moduleBackgroundColor } = this.module.config.general;

      return {
        backgroundColor: moduleBackgroundColor.value,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.gallery-section {
  container-type: inline-size;
  contain: layout;
}

.inner-wrapper {
  max-width: 1600px;
  margin: 0 auto;

  padding-inline: calc(var(--cr-module-padding-large) / 2);

  @include laptop {
    margin-inline: var(--cr-spacing-l);
    padding-inline: 0;
  }

  @include tablet {
    margin-inline: var(--cr-spacing-m);
    padding-inline: 0;
  }

  @include mobile {
    margin-inline: var(--cr-spacing-xs);
    padding-inline: 0;
  }
}

.gallery-wrapper {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;

  @include mobile {
    grid-template-columns: 1fr;
  }
}
</style>
